import { createContext } from 'react';

export interface RedirectToDashboardContextValue {
  isRedirectingToDashboard: boolean;
  redirectToDashboard: () => void;
}

const RedirectToDashboardContext =
  createContext<RedirectToDashboardContextValue | null>(null);

export default RedirectToDashboardContext;
